import { initializeApp, getApps, getApp, type FirebaseApp } from 'firebase/app'
import { getAuth, type Auth, setPersistence, browserLocalPersistence } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'
import { getStorage } from 'firebase/storage'

// إعداد Firebase الموحّد — يعمل محلياً وفي الإنتاج. نسخة الإنتاج تستخدمه دائماً لتجنب 403 على token refresh.
const defaultConfig = {
  apiKey: 'AIzaSyANGI8tiYUoPfqA-b1OKjgfoZv2zbEGEQ0',
  authDomain: 'welamart-cef13.firebaseapp.com',
  projectId: 'welamart-cef13',
  storageBucket: 'welamart-cef13.firebasestorage.app',
  messagingSenderId: '828672566266',
  appId: '1:828672566266:web:94ea5dc4d6725944847a43',
  measurementId: 'G-906T7X6HLQ',
}

const isProduction = import.meta.env.PROD
const firebaseConfig = {
  apiKey: isProduction ? defaultConfig.apiKey : (import.meta.env.VITE_FIREBASE_API_KEY || defaultConfig.apiKey),
  authDomain: isProduction ? defaultConfig.authDomain : (import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || defaultConfig.authDomain),
  projectId: isProduction ? defaultConfig.projectId : (import.meta.env.VITE_FIREBASE_PROJECT_ID || defaultConfig.projectId),
  storageBucket: isProduction ? defaultConfig.storageBucket : (import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || defaultConfig.storageBucket),
  messagingSenderId: isProduction ? defaultConfig.messagingSenderId : (import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || defaultConfig.messagingSenderId),
  appId: isProduction ? defaultConfig.appId : (import.meta.env.VITE_FIREBASE_APP_ID || defaultConfig.appId),
  measurementId: isProduction ? defaultConfig.measurementId : (import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || defaultConfig.measurementId),
}

export const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)

/** يُستدعى قبل أي استخدام لـ auth — يضمن استخدام browserLocalPersistence حتى لا تنتهي الجلسة عند إغلاق التبويب */
export const authPersistenceReady: Promise<void> = setPersistence(auth, browserLocalPersistence).catch((e) => {
  console.warn('Auth persistence setup failed:', e)
})

export const db = getFirestore(app)
export const functions = getFunctions(app)
export const storage = getStorage(app)

// Auth ثانوي لإنشاء المستخدمين من لوحة التحكم بدون لمس جلسة الأدمن الحالية
let _adminUserCreateApp: FirebaseApp | null = null
let _adminUserCreateAuth: Auth | null = null

export function getAdminUserCreateAuth(): Auth {
  if (_adminUserCreateAuth) return _adminUserCreateAuth

  const existing = getApps().find((a) => a.name === 'admin-user-create')
  const secondaryApp = existing ?? initializeApp(firebaseConfig, 'admin-user-create')
  _adminUserCreateApp = secondaryApp
  _adminUserCreateAuth = getAuth(secondaryApp)
  return _adminUserCreateAuth
}
